import { agentService } from "./agent.service";
import Logger from "./logger.service";
import { store } from "../context/store";
import { updateAgentConversation, handleNewAcceptedChatRequest, handleNewIncomingChatRequest, handleReloadState, handleActiveSessionId, updateIsAgentFirstReplay } from "../context/digitalSlice";
import { showErrorNotification } from "../components/common/NotiService";
import { getAgentData } from "./util";
import { loading } from "../context/toolbarSlice";
import HttpService from "./http.service";

const MessageService = (function () {
    let service = {};
    service.handleAWSFileUpload = async function (file, activeChat, text = '') {
        var formData = new FormData();
        formData.append("fileName", file);
        formData.append("apiKey", getAgentData().agentInfo.user.apiKey)
        const bodyParams = {
            processData: false, contentType: false
        };
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        };
        let response = await HttpService.uploadChatFiles("chat_upload", formData, { params: bodyParams }, config)
        if (response?.data) {
            if (response.data?.status == "success") {
                this.agentMediaMsgStatus(response.data.message, file, activeChat, text)
            }
            else {
                showErrorNotification(response.data.message);
            }
        }
    }
    service.agentMediaMsgStatus = async function (url, file, activeChat, text = '') {
        try {
            let res = await agentService('agentMediaMsg', {
                url: url,
                mediaType: file.type,
                fileName: file.name,
                text: text || null,
                did: activeChat.chatDetails.did ? activeChat.chatDetails.did : null,
                chatCustSessionId: activeChat.chatCustSessionId,
                clientId: activeChat.chatCustSessionId,
            })
            if (res.status === "Success") {
                store.dispatch(updateAgentConversation({ chatCustSessionId: activeChat.chatCustSessionId, agentMsg: url, type: file.type, agentId: getAgentData().agentInfo.agentId, text: text || '' }));
            }
        }
        catch (e) {
            Logger.info(e)
        }
    }
    service.acceptChat = async function (data) {
        store.dispatch(loading(true));
        try {
            let res = await agentService('tbAcceptChat', {
                did: data.did,
                chatCustSessionId: data.sessionId,
                monitorUcid: data.monitorUcid,
                campaignId: data.campaignId,
                custName: data.custName,
                clientId: data.clientId,
                skillName: data.skillName,
            })
            store.dispatch(loading(false));
            return res;
        }
        catch (e) {
            Logger.error(e)
            store.dispatch(loading(false));
        }
    }
    service.agentRelease = async function (data) {
        try {
            let res = await agentService('tbAgentRelease', {
                params: data.mode.toUpperCase(),
                mes: null,
                campId: data.campId,
            })
            return res;
        }
        catch (e) {
            Logger.error(e)
        }
    }
    service.getCustomerData = async function () {
        try {
            let res = await agentService('tbGetCustomerData', {
                params: null,
                callType: null,
                monitorUcid: null,
                did: null,
            })
            return res;
        }
        catch (e) {
            Logger.error("chat Agents list api error in digital", e)
        }
    }
    service.disposeChat = async function (data, sessionId) {
        try {
            let res = await agentService('disposeChat', {
                disp: data.disposition,
                comment: data.comment,
                sessionId: sessionId,
                monitorUcid: data.monitoUcid,
            })
            return res;
        }
        catch (e) {
            Logger.error(e)
        }
    }

    service.handleUnAnsweredChatEndedByCustomer = async function (data) {
        data.disposition = "";
        data.comment = "";
        data.monitoUcid = "";
        let res = await service.disposeChat(data, data.chatCustSessionId);
        if (res.resp === 'Success') {
            return true
        }
    }
    service.multiAgentChatMsgStatus = async function (inputText, chatCustSessionId, activeChat) {
        let isFirst = store.getState().digital.firstSessions.hasOwnProperty(chatCustSessionId) ? store.getState().digital.firstSessions[chatCustSessionId] : true;
        store.dispatch(updateIsAgentFirstReplay({ sessionId: chatCustSessionId, value: "1" }))
        try {
            let res = await agentService('multiAgentChatMsg', {
                text: inputText,
                isFirstReply: isFirst,
                chatCustSessionId: chatCustSessionId,
            })
            res.status === "Success" ? Logger.info('message sent successfully') : Logger.info('message failed to send')
            return res;
        }
        catch (e) {
            Logger.error(e)
        }
    }
    service.getAgentTypingStatus = async function (sessionId) {
        try {
            let res = await agentService('agentStartedTyping', {
                chatCustSessionId: sessionId,
            })
            return res;
        }
        catch (e) {
            Logger.error(e)
        }
    }
    service.getAgentNoLongerTypingStatus = async function (sessionId) {
        try {
            let res = await agentService('agentNoLongerTyping', {
                chatCustSessionId: sessionId,
            })
            return res;
        }
        catch (e) {
            Logger.error(e)
        }
    }
    service.InitChatOnCall = async function () {
        try {
            let res = await agentService('initChatOnCall', {
                callerId: null,
                skill: null,
                did: null,
                MonitorUcid: null,
                usId: null,
            })
            return res;
        }
        catch (e) {
            Logger.error("something went wrong try again...", e)
        }
    }
    service.getChatSkills = async function (did) {
        try {
            let res = await agentService('tbGetChatSkills', {
                did: did,
            })
            return res;
        }
        catch (e) {
            Logger.error("something went wrong try again...", e)
        }
    }
    service.getChatAgents = async function (did) {
        try {
            let res = await agentService('tbGetChatAgents', {
                did: did,
            })
            return res;
        }
        catch (e) {
            Logger.error("chat Agents list api error in digital", e)
        }
    }
    service.chatTransferService = async function (
        sessionId, did, transferType, selectedValue,
        isDeclineChat, transferAgentId, setTransferedAgentId, isChatSkillTransfer, campId
    ) {
        let selectedTransferType = 2;
        if (transferType === 'Skill' || transferType === 1) {
            selectedTransferType = 1;
        }
        selectedValue = transferType === "Agent" ? transferAgentId : selectedValue;
        try {
            let res = await agentService('tbChatTransfer', {
                params: [selectedTransferType, ((isDeclineChat && transferType === 1) || (selectedTransferType === 1 && isChatSkillTransfer)) ? selectedValue + "#T" : selectedValue].join(','),
                did: did,
                chatCustSessionId: sessionId,
                isDecline: isDeclineChat,
                campId: campId || '',
            })
            return res;
        }
        catch (e) {
            Logger.error(e)
            setTransferedAgentId(null)
        }
    }
    service.chatReConnet = async function (chatDetails) {
        try {
            let res = await agentService('tbReconnect', {
                mode: null,
                phoneNumber: chatDetails.phoneNumber,
                event: null,
                ucid: chatDetails.ucid,
                reconnect: 'true',
            })
            return res;
        }
        catch (e) {
            Logger.error(e)
        }
    }
    service.chatIFAgentIsChatting = async function () {
        try {
            let res = await agentService('checIfAgentIsChatting', {})
            return res
        }
        catch (e) {
            Logger.error(e)
        }
    }
    service.fetchChatSession = async function (sessionId) {
        try {
            let res = await agentService('fetchChatSession', {
                sessionId: sessionId,
            })
            return res
        }
        catch (e) {
            Logger.error(e)
        }
    }
    service.getSmartReplys = async function (sessionId) {
        try {
            let res = await agentService('getSmartReplys', {
                sessionId: sessionId,
            })
            return [
                { name: "Yes sure!" },
                { name: "Sorry to hear that" },
                { name: "I will get back to you on this" }
            ]
        }
        catch (e) {
            Logger.error(e)
        }
    }

    service.handleReLoad = async function () {
        store.dispatch(loading(true));
        let res = await MessageService.chatIFAgentIsChatting()
        if ((res.sessionList && res.sessionList.length > 0) || (res.callingSessionList && res.callingSessionList.length > 0)) {
            const triggerToolbar = !(getAgentData().params.hasOwnProperty("CHAT_AUTO_ANSWER") && (getAgentData().params["CHAT_AUTO_ANSWER"] === 'true' || getAgentData().params["CHAT_AUTO_ANSWER"] === true))
            if (res.sessionList && res.sessionList.length > 0) {  // for answered chats list 
                res.sessionList.forEach(async (sessionId) => {
                    let token = await MessageService.fetchChatSession(sessionId)
                    if (token) {
                        store.dispatch(handleNewAcceptedChatRequest(token))
                        store.dispatch(handleReloadState())
                    }
                });

            }
            if (res.callingSessionList && res.callingSessionList.length > 0) {   // for unAnswered chat list
                res.callingSessionList.forEach(async (sessionId) => {
                    let token = await MessageService.fetchChatSession(sessionId)
                    if (token.sessionId) {
                        store.dispatch(handleNewIncomingChatRequest(token))
                        store.dispatch(handleReloadState())
                    }
                });

            }
        }
        else {
            store.dispatch(handleActiveSessionId(null))
            Logger.info('No active sessions available')
        }
        store.dispatch(loading(false));
    }
    return service;

}());



export default MessageService;